import { size, map } from 'lodash/fp';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { getNoteIdsSortedByServiceOrderId } from '@mews-commander/legacy-entities/src/ducks/serviceOrderNotes';
import { showAllServiceOrderNotes } from '../../../selectors';
import NotesListItem from './NotesListItem';
import NoteListToggle from './NoteListToggle';

// @ts-expect-error $TSFixMeError: Type 'unknown' is not assignable to type 'Key | null | undefined'.
const mapOtherNotes = map((noteId) => <NotesListItem noteId={noteId} key={noteId} />);

const NotesList = ({ noteIds, scope, showAllNotes, serviceOrderId }: $TSFixMe) => {
    const [firstNoteId, ...otherNoteIds] = noteIds;
    return (
        <>
            {firstNoteId ? <NotesListItem noteId={firstNoteId} key={firstNoteId} /> : null}
            {showAllNotes ? mapOtherNotes(otherNoteIds) : null}
            {size(noteIds) > 1 ? <NoteListToggle serviceOrderId={serviceOrderId} scope={scope} /> : null}
        </>
    );
};

export default connect(
    // @ts-expect-error $TSFixMeError: No overload matches this call.
    createStructuredSelector({
        showAllNotes: showAllServiceOrderNotes,
        noteIds: getNoteIdsSortedByServiceOrderId,
    })
)(NotesList);
